import { render, staticRenderFns } from "./NominasList.vue?vue&type=template&id=4291f8fb&scoped=true&"
import script from "./NominasList.vue?vue&type=script&lang=js&"
export * from "./NominasList.vue?vue&type=script&lang=js&"
import style0 from "./NominasList.vue?vue&type=style&index=0&id=4291f8fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4291f8fb",
  null
  
)

export default component.exports